// Module
var code = "<iframe src=\"https://com.ia.parts/\" title=\"app\" frameborder=\"0\" allow=\"microphone; camera\" allowfullscreen></iframe>";
// Exports
export default code;